/**
 * API Client Configuration
 * Base Axios instances for all API endpoints
 */
import axios from "axios";

/**
 * IBAS API Client
 * Main business application service
 */
export const ibasClient = axios.create({
  baseURL: process.env.VUE_APP_IBAS_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Broker API Client
 * Retailer broker service for SKU and product management
 */
export const brokerClient = axios.create({
  baseURL: process.env.VUE_APP_BROKER_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Location API Client
 * Location and serviceability checking service
 */
export const locationClient = axios.create({
  baseURL: process.env.VUE_APP_LOCATION_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * NIAP API Client
 * Network Integration and Provisioning service
 */
export const niapClient = axios.create({
  baseURL: process.env.VUE_APP_NIAP_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * OTP/SMS API Client
 * One-time password and SMS verification service
 */
export const otpClient = axios.create({
  baseURL: process.env.VUE_APP_OTP_API,
  headers: {
    "Content-Type": "application/json",
  },
  auth: {
    username: process.env.VUE_APP_OTP_USERNAME,
    password: process.env.VUE_APP_OTP_PASSWORD,
  },
});

/**
 * Load API Client
 * Load management service
 */
export const loadClient = axios.create({
  baseURL: process.env.VUE_APP_LOAD_API,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * SMS API Client with Auth
 * SMS operations using IBAS API with authorization
 */
export const smsClient = axios.create({
  baseURL: process.env.VUE_APP_IBAS_API,
  headers: {
    "Content-Type": "application/json",
    Authorization: process.env.VUE_APP_SMS_AUTH_TOKEN,
  },
});
